import { render, staticRenderFns } from "./blog-img.vue?vue&type=template&id=fc2880e8&scoped=true&"
import script from "./blog-img.vue?vue&type=script&lang=js&"
export * from "./blog-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2880e8",
  null
  
)

export default component.exports